import { Search } from "lucide-react";
import { Accordion, AccordionTrigger, AccordionContent, AccordionItem } from "@/dentlab/src/components/ui/accordion";
import { Input } from "@mui/material";
import { useSearchStore } from "../../store/Search";
import { CustomMobileDialog } from "./custom-mobile-dialog.component";
import { JobSearchResult } from "@/dentlab/src/store/Search/types";
import { useEffect, useState } from "react";
import { PatientSearchResult } from "@/dentlab/src/store/Search/types";
import { useNavigate } from "react-router-dom";

export const SearchDialogComponent = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const [searchResultsJobs, setSearchResultsJobs] = useState<JobSearchResult[]>([]);
  const [searchResultsPatients, setSearchResultsPatients] = useState<PatientSearchResult[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { fetchSearchResults } = useSearchStore.getState();
  const navigate = useNavigate();

  const searchItems = async (query: string) => {
    const { jobs, patients } = await fetchSearchResults(query);
    setSearchResultsJobs(jobs);
    setSearchResultsPatients(patients);
  };

  useEffect(() => {
    searchItems(searchQuery);
  }, [searchQuery]);

  const handleClose = () => {
    setSearchResultsJobs([]);
    setSearchResultsPatients([]);
    setSearchQuery("");
    onClose();
  };

  return (
    <CustomMobileDialog
      open={open}
      onClose={handleClose}
      title="Suche"
    >
      <div className="h-full flex flex-col overflow-hidden p-4">
        <div className="flex-none">
          <div className="flex items-center">
            <Input
              placeholder="Suche"
              endAdornment={<Search size={20} className="mr-2" />}
              onChange={(e) => {
                setSearchQuery(e.target.value);
              }}
              fullWidth
              autoFocus
            />
          </div>
        </div>
        <div className="flex-1 overflow-y-auto mt-4">
          {searchQuery.length > 0 && (
            <div className="flex flex-col gap-2 pb-2">
              {/* Jobs Accordion */}
              <Accordion type="single" collapsible value={searchResultsJobs.length > 0 ? "jobs" : ""}>
                <AccordionItem value="jobs">
                <AccordionTrigger>
                  <div className="text-lg">Aufträge {searchQuery.length > 0 ? `(${searchResultsJobs.length})` : ""}</div>
                </AccordionTrigger>
                <AccordionContent>
                  <div className="flex flex-col gap-2">
                    {searchResultsJobs.length > 0 ? (
                      searchResultsJobs.map((job) => (
                        <div 
                          key={job.id} 
                          className="p-2 bg-blue-100 rounded cursor-pointer transition-colors active:bg-blue-200"
                          onClick={() => {
                            handleClose();
                            navigate(`/job/${job.id}`);
                          }}
                        >
                          <div className="text-lg">{job.title}</div>
                          {job.code && <div className="text-gray-500 text-sm">{job.code}</div>}
                        </div>
                      ))
                    ) : (
                      searchQuery.length > 0 && (
                        <div className="text-center py-2">Keine Jobs gefunden</div>
                      )
                    )}
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
            
            {/* Patients Accordion */}
            <Accordion type="single" collapsible value={searchResultsPatients.length > 0 ? "patients" : ""}>
              <AccordionItem value="patients">
                <AccordionTrigger>
                  <div className="text-lg">Patienten {searchQuery.length > 0 ? `(${searchResultsPatients.length})` : ""}</div>
                </AccordionTrigger>
                <AccordionContent>
                  <div className="flex flex-col gap-2">
                    {searchResultsPatients.length > 0 ? (
                      searchResultsPatients.map((patient) => (
                        <div 
                          key={patient.id} 
                          className="p-2 bg-blue-100 rounded cursor-pointer transition-colors active:bg-blue-200"
                          onClick={() => {
                            handleClose();
                            navigate(`/patient/${patient.id}`);
                          }}
                        >
                          <div className="text-lg">{patient.first_name} {patient.last_name}</div>
                          {patient.code && <div className="text-gray-500 text-sm">{patient.code}</div>}
                        </div>
                      ))
                    ) : (
                      searchQuery.length > 0 && (
                        <div className="text-center py-2">Keine Patienten gefunden</div>
                      )
                    )}
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          
        </div>
        )}
        </div>
      </div>
    </CustomMobileDialog>
  );
};
